import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const ContactPage = () => {
  return (
    <div>
      <Helmet>
        <title>Contact Us | Dhanam Information System</title>
      </Helmet>
      <NavBar />
      <section className="contact-banner text-white text-center py-5">
        <h1 className="fw-bold">Get In Touch With Us</h1>
        <p className="lead">
          Have questions or want to discuss a project? We'd love to hear from
          you.
        </p>
      </section>{" "}
      <section>
      
      </section>
      <section className="py-5">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="mb-4 mb-md-0">
              <img
                src="https://img.freepik.com/free-vector/contact-us-concept-landing-page_52683-12860.jpg"
                alt="Contact Us Illustration"
                className="img-fluid rounded-4"
              />
            </Col>
            <Col md={6}>
              <h2 className="fw-bold mb-4" style={{ color: "rgb(11, 22, 63)" }}>
                Send Us a Message
              </h2>
              <Form>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control type="text" placeholder="Enter your name" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control type="email" placeholder="Enter your email" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formSubject">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control type="text" placeholder="Subject" />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formMessage">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Type your message here"
                  />
                </Form.Group>

                <Button variant="dark" type="submit" className="px-4 py-2">
                  Send Message
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
      <style jsx>{`
        .contact-banner {
          background-color: rgb(11, 22, 63);
        }

        .form-control:focus {
          border-color: #0b163f;
          box-shadow: 0 0 0 0.2rem rgba(11, 22, 63, 0.25);
        }
      `}</style>
    </div>
  );
};

export default ContactPage;
